
export function traduzirErro(error: any): string {
  const resposta = error?.response?.data;

  console.error("Erro completo da API:", resposta ?? error);

  const mensagem = resposta?.message ?? error?.message;

  if (Array.isArray(mensagem)) {
    return mensagem
      .map((item) => traduzirMensagem(String(item)))
      .join("\n");
  }

  if (typeof mensagem === "string") {
    return traduzirMensagem(mensagem);
  }

  return resposta
    ? JSON.stringify(resposta, null, 2)
    : "Não foi possível concluir a operação.";
}

function traduzirMensagem(mensagem: string): string {
  const erro = mensagem.toLowerCase();

  // Campo enviado que não existe na API.
  if (erro.includes("should not exist")) {
    return `A API rejeitou um campo: ${mensagem}`;
  }

  // CPF e CNPJ.
  if (erro.includes("cpf must be a valid cpf")) {
    return "CPF inválido. Verifique os números informados.";
  }

  if (erro.includes("cnpj must be a valid cnpj")) {
    return "CNPJ inválido. Verifique os números informados.";
  }

  // E-mail e usuário.
  if (erro.includes("this email is already registered")) {
    return "Este e-mail já está cadastrado. Faça login para continuar.";
  }

  if (
    erro.includes("email already exists") ||
    erro.includes("user already exists")
  ) {
    return "Este e-mail já está cadastrado.";
  }

  if (erro.includes("username already exists")) {
    return "Este usuário já está cadastrado.";
  }

  if (
    erro.includes("email must be an email") ||
    erro.includes("must be an email")
  ) {
    return "Informe um e-mail válido.";
  }

  // Autenticação e senha.
  if (erro.includes("incorrect username or password")) {
    return "Usuário ou senha incorretos.";
  }

  if (erro.includes("user not found")) {
    return "Usuário não encontrado.";
  }

  if (erro.includes("invalid password")) {
    return "A senha informada é inválida.";
  }

  if (erro.includes("password must be longer than or equal to 8 characters")) {
    return "A senha informada não atende aos requisitos.";
  }

  if (erro.includes("password must be")) {
    return "A senha informada não atende aos requisitos.";
  }

  // Validações genéricas.
  if (erro.includes("must be longer than or equal to 8 characters")) {
    return "Deve ter pelo menos 8 caracteres.";
  }

  if (erro.includes("must be longer than or equal to 1 characters")) {
    return "Este campo é obrigatório.";
  }

  if (erro.includes("should not be empty") || erro.includes("is required")) {
    return "Este campo é obrigatório.";
  }

  if (erro.includes("must be a string")) {
    return "Informe um texto válido.";
  }

  if (erro.includes("must be a number")) {
    return "Informe um número válido.";
  }

  if (erro.includes("must be a boolean")) {
    return "Informe uma opção válida.";
  }

  if (
    erro.includes("must be a valid uuid") ||
    erro.includes("must be an uuid")
  ) {
    return "O identificador informado é inválido.";
  }

  // Telefone.
  if (erro.includes("phone") && erro.includes("invalid")) {
    return "Telefone inválido. Verifique o número informado.";
  }

  // CEP.
  if (erro.includes("cep") && erro.includes("invalid")) {
    return "CEP inválido. Verifique o CEP informado.";
  }

  if (erro.includes("cep") && erro.includes("not found")) {
    return "CEP não encontrado. Verifique o CEP informado.";
  }

  if (erro.includes("postal code") || erro.includes("zip code")) {
    return "CEP inválido. Verifique o CEP informado.";
  }

  // Endereço.
  if (erro.includes("address") && erro.includes("not found")) {
    return "Endereço não encontrado.";
  }

  if (erro.includes("address already exists")) {
    return "Este endereço já está cadastrado.";
  }

  // SKU.
  if (erro.includes("sku") && erro.includes("already exists")) {
    return "Este SKU já está cadastrado.";
  }

  if (
    erro.includes("sku") &&
    (erro.includes("required") || erro.includes("empty"))
  ) {
    return "Informe o SKU do produto.";
  }

  // Produtos e categorias.
  if (erro.includes("product") && erro.includes("already exists")) {
    return "Este produto já está cadastrado.";
  }

  if (erro.includes("product") && erro.includes("not found")) {
    return "Produto não encontrado.";
  }

  if (erro.includes("category") && erro.includes("not found")) {
    return "Categoria não encontrada.";
  }

  if (erro.includes("store") && erro.includes("not found")) {
    return "Loja não encontrada.";
  }

  // Preço.
  if (
    erro.includes("price") &&
    (erro.includes("positive") || erro.includes("greater than"))
  ) {
    return "O preço deve ser maior que zero.";
  }

  if (erro.includes("price")) {
    return "Informe um preço válido.";
  }

  // Estoque.
  if (
    erro.includes("stock") &&
    (erro.includes("positive") || erro.includes("greater than"))
  ) {
    return "O estoque deve ser maior que zero.";
  }

  if (erro.includes("stock")) {
    return "Informe um estoque válido.";
  }

  // Imagens e arquivos.
  if (
    erro.includes("image") ||
    erro.includes("imagem") ||
    erro.includes("file")
  ) {
    if (
      erro.includes("format") ||
      erro.includes("type") ||
      erro.includes("extension")
    ) {
      return "Formato de imagem não permitido.";
    }

    if (erro.includes("size") || erro.includes("large")) {
      return "A imagem é muito grande.";
    }
  }

  // Dados bancários.
  if (
    erro.includes("account check digit must be numeric or x") ||
    erro.includes("accountdigit must be numeric")
  ) {
    return "O dígito da conta deve ser um número ou X.";
  }

  if (
    erro.includes("accountdigit") &&
    erro.includes("longer than or equal to 1")
  ) {
    return "Este campo é obrigatório.";
  }

  if (
    erro.includes("invalid_parameter") &&
    erro.includes("agencia") &&
    erro.includes("value too long")
  ) {
    return "A agência informada é muito longa. Verifique o número da agência.";
  }

  if (erro.includes("bankcode")) {
    return "Banco inválido. Selecione um banco válido.";
  }

  if (erro.includes("branch")) {
    return "Agência inválida. Verifique os dados informados.";
  }

  if (erro.includes("account")) {
    return "Conta bancária inválida. Verifique os dados informados.";
  }

  if (erro.includes("value too long")) {
    return "Um dos dados informados ultrapassa o limite permitido. Verifique os campos preenchidos.";
  }

  // Erros gerais.
  if (erro.includes("already exists")) {
    return "Este cadastro já existe.";
  }

  if (erro.includes("not found")) {
    return "Registro não encontrado.";
  }

  if (erro.includes("unauthorized") || erro.includes("not authorized")) {
    return "Você não tem autorização para realizar esta operação.";
  }

  if (erro.includes("forbidden")) {
    return "Você não tem permissão para realizar esta operação.";
  }

  if (erro.includes("network error")) {
    return "Não foi possível conectar ao servidor. Tente novamente.";
  }

  // Mensagem desconhecida: preserva o texto original.
  return mensagem;
}
